import { getLightToken } from './light';
import { getDarkToken } from './dark';
export function getThemeToken(zoomUI) {
    return {
        light: getLightToken(zoomUI),
        dark: getDarkToken(zoomUI),
    };
}
